import React from "react";
import {
  Grid,
  TextField,
  MenuItem,
  Typography,
  Box,
  Button,
} from "@mui/material";
import { Field, FieldArray } from "formik";

export default function ProductVariationsSection({
  values,
  setFieldValue,
  DeleteProductOption,
}) {
  return (
    <>
      <Grid item xs={12} md={6}>
        <Field
          as={TextField}
          select
          name="variationType"
          label="סוג וריאציות"
          fullWidth
        >
          <MenuItem value="">ללא</MenuItem>
          <MenuItem value="Color">צבע</MenuItem>
          <MenuItem value="Size">לבחירה</MenuItem>
        </Field>
      </Grid>

      {values.variationType && (
        <Grid item xs={12}>
          <Typography
            sx={{
              mt: 1,
              mb: 1,
              fontWeight: 700,
            }}
          >
            אופציות ל-
            {values.variationType === "Color"
              ? "צבע"
              : "בחירה"}
          </Typography>

          <FieldArray name="options">
            {({ push, remove }) => (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 2,
                }}
              >
                {(values.options || []).map((opt, idx) => (
                  <Grid
                    container
                    spacing={2}
                    key={opt.id || idx}
                    alignItems="center"
                  >
                    <Grid item xs={12} md={3}>
                      <Field
                        as={TextField}
                        name={`options.${idx}.value`}
                        label={
                          values.variationType === "Color"
                            ? "צבע"
                            : "בחירה"
                        }
                        fullWidth
                      />
                    </Grid>

                    <Grid item xs={12} md={2}>
                      <Field
                        as={TextField}
                        name={`options.${idx}.extraPrice`}
                        label="מחיר וריאציה"
                        type="number"
                        fullWidth
                      />
                    </Grid>

                   

                    <Grid item xs={12} md={3}>
                      <Button
                        type="button"
                        variant="outlined"
                        component="label"
                        fullWidth
                      >
                        העלאת תמונה

                        <input
                          type="file"
                          hidden
                          accept="image/*"
                          onChange={(e) => {
                            const file =
                              e.target.files?.[0];

                            if (!file) return;

                            const maxSize =
                              2 * 1024 * 1024;

                            if (file.size > maxSize) {
                              alert(
                                "התמונה גדולה מדי. ניתן להעלות תמונה עד 2MB בלבד"
                              );

                              e.target.value = "";
                              return;
                            }

                            setFieldValue(
                              `options.${idx}.image`,
                              file
                            );
                          }}
                        />
                      </Button>

                      {values.options?.[idx]?.image && (
                        <Typography
                          sx={{
                            mt: 1,
                            fontSize: 12,
                          }}
                        >
                          נבחרה תמונה
                        </Typography>
                      )}
                    </Grid>

                    <Grid item xs={12} md={2}>
                      <Button
                        type="button"
                        variant="outlined"
                        color="error"
                        fullWidth
                        onClick={() => {
                          const optionId =
                            values.options?.[idx]?.id;

                          remove(idx);

                          if (
                            optionId &&
                            optionId !== 0
                          ) {
                            DeleteProductOption(
                              optionId
                            ).catch((err) =>
                              console.error(
                                "Delete failed",
                                err
                              )
                            );
                          }

                          const remaining =
                            (values.options || [])
                              .length - 1;

                          if (remaining <= 0) {
                            setFieldValue(
                              "options",
                              [
                                {
                                  id: 0,
                                  value: "",
                                  extraPrice: 0,
                                  quantity: 0,
                                  image: null,
                                  isInStock: true,
                                },
                              ]
                            );
                          }
                        }}
                      >
                        מחק
                      </Button>
                    </Grid>
                     <Grid item xs={12} md={2}>
                      <Button
                        type="button"
                        variant="contained"
                        color={
                          opt.isInStock ?? true
                            ? "success"
                            : "error"
                        }
                        sx={{
                          minWidth: 0,
                          px: 1.5,
                        }}
                        onClick={() => {
                          setFieldValue(
                            `options.${idx}.isInStock`,
                            !(opt.isInStock ?? true)
                          );
                        }}
                      >
                        {opt.isInStock ?? true
                          ? "במלאי"
                          : "לא במלאי"}
                      </Button>
                    </Grid>
                  </Grid>
                ))}

                <Button
                  type="button"
                  variant="contained"
                  onClick={() =>
                    push({
                      id: 0,
                      value: "",
                      extraPrice: 0,
                      quantity: 0,
                      image: null,
                      isInStock: true,
                    })
                  }
                >
                  הוסף אופציה
                </Button>
              </Box>
            )}
          </FieldArray>
        </Grid>
      )}
    </>
  );
}